import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

// project imports
import { APP_DEFAULT_PATH } from 'config';



// ==============================|| MAIN LOGO ||============================== //

export default function LogoSection({ reverse, isIcon, sx, to, logoHeight }) {
  const [companyLogo, setCompanyLogo] = useState(null);
  const [appName, setAppName] = useState('');
  const [appAbbr, setAppAbbr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch perusahaan data untuk mengambil logo dan ico
        const apiUrl = import.meta.env.VITE_APP_API_URL || '';
        const resPerusahaan = await fetch(`${apiUrl}/perusahaan`);
        if (resPerusahaan.ok) {
          const dataPerusahaan = await resPerusahaan.json();
          if (dataPerusahaan && dataPerusahaan.length > 0) {
            const company = dataPerusahaan[0];

            if (company.ico) {
              let link = document.querySelector("link[rel~='icon']");
              if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.head.appendChild(link);
              }
              link.href = company.ico;
            }

            const imgBase = import.meta.env.VITE_APP_IMAGE_URL || '/img/';

            if (company.logo) {
              setCompanyLogo(imgBase + company.logo);
            }
          }
        }
      } catch (err) {
        console.error('Error fetching perusahaan logo:', err);
      }

      try {
        // Fetch nama aplikasi
        const apiUrl = import.meta.env.VITE_APP_API_URL || '';
        const resApp = await fetch(`${apiUrl}/aplikasi?id_perusahaan=1`);
        if (resApp.ok) {
          const dataApp = await resApp.json();
          if (dataApp) {
            setAppName(dataApp.nama_aplikasi || 'Aplikasi');
            setAppAbbr(dataApp.singkatan || 'APP');
          }
        }
      } catch (err) {
        console.error('Error fetching aplikasi data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <ButtonBase disableRipple component={Link} to={to || APP_DEFAULT_PATH} sx={sx} aria-label="Logo">
      {loading ? (
        <Skeleton variant="text" width={isIcon ? 35 : 120} height={40} />
      ) : (
        <img
          src={companyLogo || '/img/df.png'}
          alt="Company Logo"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/img/df.png';
          }}
          style={{ height: logoHeight ? logoHeight : isIcon ? '28px' : '35px', objectFit: 'contain' }}
        />
      )}
    </ButtonBase>
  );
}

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.any,
  to: PropTypes.any,
  logoHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
